import Model from 'flarum/common/Model';
import transformDate from '../utils/transformDate';
export default class Season extends Model {
  name = Model.attribute('name');
  slug = Model.attribute('slug');
  startDate = Model.attribute('startDate', transformDate);
  endDate = Model.attribute('endDate', transformDate);
}
flarum.reg.add('huseyinfiliz-pickem', 'common/models/Season', Season);